import mutations from './mutations'
import actions from './action'
import getters from './getters'

export default {
  namespaced: true,
  state: {
    user: [],
    uploadhistory: [
      {
        icon: 'w-icon-back',
        title: '返回主页',
        path: '/home'
      }, {
        icon: 'w-icon-lishishangchuan',
        title: '上传中',
        isClick: true,
        children: [
          {
            icon: 'w-icon-gongchengguanli',
            title: '工程上传记录',
            path: '/upload/doing/project'
          }, {
            icon: 'w-icon-yunshujuguanli',
            title: '数据上传记录',
            children: [
              {
                icon: 'w-icon-shujuwenjian',
                title: '清单数据',
                path: '/upload/doing/list'
              }, {
                icon: 'w-icon-shujuwenjian',
                title: '组价数据',
                path: '/upload/doing/group'
              }
            ]
          }
        ]
      }, {
        icon: 'w-icon-ok1',
        title: '已上传',
        isClick: true,
        children: [
          {
            icon: 'w-icon-gongchengguanli',
            title: '工程上传记录',
            path: '/upload/done/project',
            point: false
          }, {
            icon: 'w-icon-yunshujuguanli',
            title: '数据上传记录',
            children: [
              {
                icon: 'w-icon-shujuwenjian',
                title: '清单数据',
                path: '/upload/done/list',
                point: false
              }, {
                icon: 'w-icon-shujuwenjian',
                title: '组价数据',
                path: '/upload/done/group',
                point: false
              }
            ]
          }
        ]
      }
    ],
    feedback: [
      {
        icon: 'w-icon-back',
        title: '返回主页',
        path: '/home'
      }, {
        icon: 'w-icon-my_feedback',
        title: '意见反馈',
        path: '/feedback/add'
      }, {
        icon: 'w-icon-my_feedback',
        title: '反馈成功',
        path: '/feedback/success',
        hide: true
      }, {
        icon: 'w-icon-advice_feedback',
        title: '我的反馈',
        path: '/feedback/list',
        log: {
          1: ['查看反馈', '管理账号-点击我的反馈', '100240203'],
          2: ['查看反馈', '个人账号-点击我的反馈', '100240201'],
          3: ['查看反馈', '员工账号-点击我的反馈', '100240202']
        }
      }
    ],
    active: '',
    sidebarReady: false // 菜单数据已获取
  },
  getters,
  actions,
  mutations,
  modules: {}
}
